// Design tokens for JS consumers (react-select styles, echarts options,
// AG Grid theme params) — the CSS side lives in src/tailwind.css. Values must
// stay in sync with the --color-primary-* / semantic variables declared there.

export const FONT_FAMILY =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

// Tailwind blue family — tw-primary-* in class form.
export const PRIMARY = {
  50: '#eff6ff',
  100: '#dbeafe',
  200: '#bfdbfe',
  300: '#93c5fd',
  400: '#60a5fa',
  500: '#3b82f6',
  600: '#2563eb',
  700: '#1d4ed8',
  800: '#1e40af',
  900: '#1e3a8a',
  950: '#172554'
};

// Neutral ramp — tw-slate-*.
export const SLATE = {
  50: '#f8fafc',
  100: '#f1f5f9',
  200: '#e2e8f0',
  300: '#cbd5e1',
  400: '#94a3b8',
  500: '#64748b',
  600: '#475569',
  700: '#334155',
  800: '#1e293b',
  900: '#0f172a'
};

// Status colors — match the toast accents in src/tailwind.css.
export const SEMANTIC = {
  success: '#16a34a', // green-600
  warning: '#d97706', // amber-600
  danger: '#dc2626', // red-600
  info: PRIMARY[600]
};

// Semantic surface/text aliases (mirror the CSS variables).
export const SURFACE = {
  ground: SLATE[100],
  card: '#ffffff',
  borderSubtle: SLATE[200]
};

export const TEXT = {
  primary: SLATE[900],
  secondary: SLATE[600],
  muted: SLATE[500]
};
